import SceneBroadbandLight from '@utilitywarehouse/hearth-svg-assets/lib/scene-broadband-light.svg';
import SceneInsuranceLight from '@utilitywarehouse/hearth-svg-assets/lib/scene-insurance-light.svg';
import SpotBoilerLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-boiler-light.svg';
import SpotBroadbandLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-broadband-light.svg';
import SpotConfettiLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-confetti-light.svg';
import SpotOnlineAccountLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-online-account-light.svg';

type Milestone = {
  title: string;
  desc: string;
  image: string;
};

type EarningsMilestone = {
  monthlyAmount: number;
  monthly: Milestone;
  yearly: Milestone;
};

const EARNINGS_MILESTONES: EarningsMilestone[] = [
  {
    monthlyAmount: 13,
    monthly: {
      title: 'One Go Unlimited SIM or two Go Essential SIMs paid for',
      desc: 'SIMs, fully funded by your earnings.',
      image: SpotOnlineAccountLight,
    },
    yearly: {
      title: 'A proper celebration dinner!',
      desc: 'Booking the private dining room, starters to dessert, all sorted.',
      image: SpotConfettiLight,
    },
  },
  {
    monthlyAmount: 30,
    monthly: {
      title: 'Your monthly broadband bill!',
      desc: 'High-speed internet for the whole house, paid for.',
      image: SpotBroadbandLight,
    },
    yearly: {
      title: 'A full year of fast broadband!',
      desc: '12 months of seamless streaming, browsing, and working from home.',
      image: SceneBroadbandLight,
    },
  },
  {
    monthlyAmount: 60,
    monthly: {
      title: 'Your mobile & broadband sorted!',
      desc: 'Two Go Unlimited SIMs and high speed broadband.',
      image: SceneInsuranceLight,
    },
    yearly: {
      title: 'A new household appliance!',
      desc: 'Time for that A-rated energy-efficient fridge or washing machine.',
      image: SpotBoilerLight,
    },
  },
];

export { EARNINGS_MILESTONES };
export type { Milestone, EarningsMilestone };
